import { TYPE, type Rect } from "@gaoya/shared";
import { C, fillRound } from "../theme.js";
import type { UiState } from "../../game/state.js";

function chainAdvance(ctx: CanvasRenderingContext2D, word: string, last: boolean): number {
  return ctx.measureText(word).width + 14 + 6 + (last ? 0 : 16);
}

export function chainContentWidth(ctx: CanvasRenderingContext2D, chain: readonly string[]): number {
  ctx.font = `13px ${TYPE.serif}`;
  let w = 0;
  for (let i = 0; i < chain.length; i++) {
    w += chainAdvance(ctx, chain[i] ?? "", i === chain.length - 1);
  }
  return w;
}

export function drawScroll(ctx: CanvasRenderingContext2D, ui: UiState, r: Rect): void {
  fillRound(ctx, r.x + 12, r.y + 6, r.w - 24, r.h - 12, (r.h - 12) / 2, "rgba(241,232,216,0.85)");
  ctx.save();
  ctx.beginPath();
  ctx.rect(r.x + 16, r.y + 6, r.w - 32, r.h - 12);
  ctx.clip();
  const chain = ui.wordChain;
  ctx.font = `13px ${TYPE.serif}`;
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  const inner = r.w - 36;
  const content = chainContentWidth(ctx, chain);
  const maxScroll = Math.max(0, content - inner + 8);
  if (ui.scrollFollow) ui.scrollX = maxScroll;
  else ui.scrollX = Math.max(0, Math.min(ui.scrollX, maxScroll));
  let x = r.x + 20 - ui.scrollX;
  const y = r.y + r.h / 2;
  if (chain.length === 0) {
    ctx.fillStyle = C.ink3;
    ctx.fillText("联句 · 对局成语将写在此处", x, y);
  } else {
    for (let i = 0; i < chain.length; i++) {
      const word = chain[i] ?? "";
      const tw = ctx.measureText(word).width + 14;
      if (i === chain.length - 1) {
        fillRound(ctx, x, y - 11, tw, 22, 11, C.card);
      }
      ctx.fillStyle = i === chain.length - 1 ? C.seal : C.ink2;
      ctx.fillText(word, x + 6, y);
      x += tw + 6;
      if (i < chain.length - 1) {
        ctx.fillStyle = "rgba(184,58,36,0.5)";
        ctx.fillText("›", x + 3, y);
        x += 16;
      }
    }
  }
  ctx.restore();
}
